import React from 'react';
import { SkipToContent } from '~/components/accessibility/skip-to-content';
import { AnnouncementBanner } from '~/components/layout/announcement-banner';
import { Header } from '~/components/layout/header';
import { Footer } from '~/components/layout/footer';
import { RouteProgress } from '~/components/layout/route-progress';
import { ToastProvider } from '~/components/ui/feedback';

interface LayoutProps {
  children: React.ReactNode;
  announcementMessage?: string | null;
  announcementCtaLabel?: string;
  announcementCtaHref?: string;
}

export function Layout({
  children,
  announcementMessage,
  announcementCtaHref,
  announcementCtaLabel,
}: LayoutProps) {
  return (
    <ToastProvider>
      <SkipToContent />
      <Header />
      <div className="pt-[72px] md:pt-0">
        <AnnouncementBanner
          message={announcementMessage}
          ctaLabel={announcementCtaLabel}
          ctaHref={announcementCtaHref}
        />
        <RouteProgress />
        <main id="main" className="min-h-screen bg-background text-foreground">
          {children}
        </main>
        <Footer />
      </div>
    </ToastProvider>
  );
}
